import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminDashboard.css';

// --- 1. YOUR PASSWORD ---
// You can change this to whatever you want
const ADMIN_PASSWORD = "om_nidhi_admin_123";

const AdminDashboard = () => {
  const [enquiries, setEnquiries] = useState([]);

  // --- 2. "Logged In" state ---
  // This immediately checks if you are already logged in from this session
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem('admin_logged_in') === 'true'
  );

  // --- 3. State to hold the password input ---
  const [passwordInput, setPasswordInput] = useState('');
  const [error, setError] = useState('');

  // --- 4. Data fetching ---
  // This now *only* fetches data, and it will *only* run if isLoggedIn is true
  useEffect(() => {
    if (isLoggedIn) {
      axios
        .get('https://om-nidhi-backend.onrender.com/enquiries/')
        .then((res) => {
          setEnquiries(res.data);
        })
        .catch((err) => {
          console.log('Error fetching enquiries: ' + err);
          setError('Could not fetch enquiries.');
        });
    }
  }, [isLoggedIn]); // This runs when the page loads, or when 'isLoggedIn' changes

  // --- 5. Login Form Submit Handler ---
  const handleLoginSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === ADMIN_PASSWORD) {
      // Password is correct!
      setIsLoggedIn(true);
      sessionStorage.setItem('admin_logged_in', 'true'); // Save for this session
      setError('');
    } else {
      // Password is wrong!
      setError('Incorrect password. Access denied.');
      setIsLoggedIn(false);
      sessionStorage.removeItem('admin_logged_in');
    }
  };

  // --- 6. Conditional Rendering: Show Login Form ---
  // If NOT logged in, show the new Login Form
  if (!isLoggedIn) {
    return (
      <div className="admin-container login-page">
        <div className="login-box">
          <h2>Admin Login</h2>
          <form onSubmit={handleLoginSubmit}>
            <input
              type="password"
              placeholder="Enter Password"
              className="login-input"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
            />
            <button type="submit" className="login-button">
              Login
            </button>
            {error && <p className="login-error">{error}</p>}
          </form>
        </div>
      </div>
    );
  }

  // --- 7. Conditional Rendering: Show Dashboard ---
  // If we ARE logged in, show the real dashboard
  return (
    <div className="admin-container">
      <h1>Admin Dashboard: All Enquiries</h1>
      {error && <p className="login-error">{error}</p>}
      <table className="enquiries-table">
        <thead>
          <tr>
            <th>Date Submitted</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Service</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {enquiries.map((enquiry) => (
            <tr key={enquiry._id}>
              <td>{new Date(enquiry.createdAt).toLocaleString()}</td>
              <td>{enquiry.name}</td>
              <td>{enquiry.email}</td>
              <td>{enquiry.phone}</td>
              <td>{enquiry.service}</td>
              <td className="message-cell">{enquiry.message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminDashboard;